/*
 * Tupaia
 * Copyright (c) 2017 - 2020 Beyond Essential Systems Pty Ltd
 */
import React, { useState } from "react";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";
import { SearchForm } from "./SearchForm";
import { NoResultCard, ResultCard, ErrorResultCard } from "./ResultCards";
import { useLabResults } from "../../api";

const SearchContainer = styled.div`
  min-height: 10rem;
  max-width: 27rem;
`;

const validate = (inputValue) => {
  if (inputValue.length < 6 || inputValue.length > 7) {
    return "Your Test ID should be 6 or 7 characters long.";
  }

  return true;
};

export const SearchBar = () => {
  const [inputValue, setInputValue] = useState("");
  const [validationMessage, setValidationMessage] = useState(null);
  const {
    mutate,
    status,
    data,
    reset,
    variables: searchTerm,
  } = useLabResults();

  const handleChange = (event) => {
    setValidationMessage(null);
    setInputValue(event.target.value.toUpperCase());
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    reset();
    setValidationMessage(null);
    const validation = validate(inputValue);

    if (validation === true) {
      mutate(inputValue);
    } else {
      setValidationMessage(validation);
    }
  };

  const handleClear = () => {
    reset();
    setValidationMessage(null);
    setInputValue("");
  };

  return (
    <SearchContainer>
      <SearchForm
        onSubmit={handleSubmit}
        isLoading={status === "isLoading"}
        onClear={handleClear}
        value={inputValue}
        onChange={handleChange}
      />
      {status === "isLoading" && <CircularProgress size={60} />}
      {status === "areNoResults" && (
        <NoResultCard value={searchTerm} onClose={handleClear} />
      )}
      {status === "isError" && <ErrorResultCard onClose={handleClear} />}
      {status === "isSuccess" &&
        data.map((result) => {
          return (
            <ResultCard
              key={result.testDate}
              onClose={handleClear}
              initials={result.patientInitials}
              result={result?.testResults[0]?.result}
              testId={searchTerm}
              date={result.testDate}
            />
          );
        })}
      {validationMessage && (
        <ErrorResultCard
          heading="Invalid Test ID"
          text={validationMessage}
          onClose={handleClear}
        />
      )}
    </SearchContainer>
  );
};
